// Rulebook v3 — text pages written from docs/porosity-v3-spec.md
// (content lives in components/game/RulebookPages.jsx, one section per page).

// Old printed rulebook (v1 rules): 11 PNG pages + a PDF on GitHub. They are no
// longer shown because they describe the old rules. When a designed v2 PDF is
// published, point RULEBOOK_PDF_URL at it and set RULEBOOK_PDF_ENABLED = true to
// bring the "Download PDF" button back.
export const RULEBOOK_PDF_ENABLED = false;

const LEGACY_BASE = "https://raw.githubusercontent.com/harshatverma/PorosityHV/main/rulebook";
// Bump every time the rulebook files are replaced (cache-busting), same as cards and tiles.
export const RULEBOOK_VERSION = 1;
export const RULEBOOK_PDF_URL = `${LEGACY_BASE}/rulebook.pdf?v=${RULEBOOK_VERSION}`;
export const RULEBOOK_PDF_NAME = "Porosity-Rulebook.pdf";
// Legacy v1 page images (kept for reference, not rendered).
export const legacyRulebookPageSrc = (n) =>
  `${LEGACY_BASE}/page-${String(n).padStart(2, "0")}.png?v=${RULEBOOK_VERSION}`;

// Page frame: same size as the printed pages (letter at 150 dpi). Text pages
// keep this as their minimum height and grow if their content needs more room.
export const RULEBOOK_PAGE_W = 1275;
export const RULEBOOK_PAGE_H = 1650;

export const RULEBOOK_SECTIONS = [
  { page: 1, key: "overview", title: "Overview & goal" },
  { page: 2, key: "setup", title: "Setup" },
  { page: 3, key: "cards", title: "Cards" },
  { page: 4, key: "turn", title: "Your turn" },
  { page: 5, key: "economy", title: "Money, population & city size" },
  { page: 6, key: "sea", title: "Carbon meter & sea level" },
  { page: 7, key: "weather", title: "Weather deck" },
  { page: 8, key: "global", title: "Global events" },
  { page: 9, key: "bank", title: "Climate Bank" },
  { page: 10, key: "groups", title: "Groups & networks" },
  { page: 11, key: "end", title: "Resilience & winning" },
];

export const rulebookPageAlt = (section) =>
  `Porosity Rulebook, page ${section.page}: ${section.title}`;
